import EnterpriseSupportBundleInfo from "support-bundle/components/EnterpriseSupportBundleInfo";
export default {
  supportBundle: {
    EnterpriseSupportBundleInfo
  }
};
